"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DistrictStaffSerializer = void 0;
class DistrictStaffSerializer {
    constructor(schoolSerializer) {
        this.schoolSerializer = schoolSerializer;
    }
    serializeOne(data) {
        return data.map((row) => this.serialize(row));
    }
    serialize(data) {
        return Object.assign(Object.assign({}, data), { schoolAdmin: data.schoolAdmin
                ? {
                    id: data.schoolAdmin.id,
                    schools: this.serializeSchools(data.schoolAdmin.schools),
                }
                : undefined, teacher: data.teacher
                ? {
                    id: data.teacher.id,
                    teacherId: data.teacher.teacherId,
                    schools: this.serializeSchoolClasses(data.teacher.schools),
                }
                : undefined });
    }
    serializeSchools(data) {
        return data.map((row) => this.schoolSerializer.serializeOne({
            id: row.schoolId,
            name: row.schoolName,
        }));
    }
    serializeSchoolClasses(data) {
        return data.map((school) => ({
            id: school.schoolId,
            name: school.schoolName,
            classes: school.classes
                ? school.classes.map((cl) => ({
                    id: cl.classId,
                    name: cl.className,
                }))
                : undefined,
        }));
    }
}
exports.DistrictStaffSerializer = DistrictStaffSerializer;
//# sourceMappingURL=district-staff.serializer.js.map